import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { Invoice } from "../../models/invoice";

interface InvoiceCancellationRetryModalProps {
  show: boolean;
  invoice?: Invoice;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const InvoiceCancellationRetryModal: React.FC<
  InvoiceCancellationRetryModalProps
> = ({ show, invoice, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = invoice
    ? `Está seguro de que quiere reintentar la anulación de la factura nº ${invoice.establishmentCode}-${invoice.dispatchPointIdentifier}-${invoice.invoiceNumber}?`
    : "";

  const onRetryClick = async () => {
    if (invoice !== undefined) {
      setSubmitting(true);
      const status = await createItem(`/cancellations/retry/`, {
        taxPayerId: invoice.taxPayerId,
        cdcs: [invoice.cdc],
      });

      if (status.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (status.detail !== undefined) {
          message = status.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-warning" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Reintentar Anulación</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onRetryClick} color="warning">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Reintentando..." : "Reintentar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default InvoiceCancellationRetryModal;
